import { FC, memo } from "react";
import { MatchStatus } from "service";
import styled from "styled-components";
import { SIDE } from "_constants";
import { getTeamColors } from "components/colors";

export const AttackIndicator: FC<{ status: MatchStatus }> = memo(
  ({ status: { x, y, sc, nsc, side, ...status } }) => {
    const hasCoords = typeof x === "number" && typeof y === "number";
    const fx: number = hasCoords
      ? (x as number)
      : side === SIDE.HOME
      ? 0.25
      : 0.75;
    const { home, away } = getTeamColors(status as any);
    const fillColor = side === SIDE.HOME ? home : away;

    return (
      <>
        <PathContainer className="attack-indicator" side={side}>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 297 180"
            preserveAspectRatio="none"
          >
            <defs>
              <linearGradient
                id="attackGradient"
                x1="297"
                y1="90"
                x2="0"
                y2="90"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={fillColor} stopOpacity={0.75} />
                <stop
                  offset="0.246974"
                  stopColor={fillColor}
                  stopOpacity={0.5}
                />
                <stop offset="1" stopColor={fillColor} stopOpacity={0.4} />
              </linearGradient>
            </defs>

            {(nsc === "1270" ||
              nsc === "1286" ||
              nsc === "1292" ||
              nsc === "1295") && (
              <RotGroup data-side={side}>
                <AttackPath
                  data-side={side}
                  x={fx}
                  style={{ opacity: "0.7" }}
                  fill="url(#attackGradient)"
                  d="M0 52C0 23.2812 23.2812 0 52 0L257 0L297 90L257 180H52C23.2812 180 0 156.719 0 128V52Z"
                />
              </RotGroup>
            )}
          </svg>
        </PathContainer>
      </>
    );
  }
);

const PathContainer = styled.div<{ side?: SIDE }>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  padding-bottom: ${(p) => (p.side === SIDE.AWAY ? "1vw" : "0")};
  padding-top: ${(p) => (p.side === SIDE.HOME ? "2vw" : "0")};
  overflow: hidden;
  padding-inline: 1vw;

  & > svg {
    height: calc(96% + 1vw);
    display: block;
    transform: translateY(${(p) => (p.side === SIDE.HOME ? "-1vw" : "0")});
  }
`;

const RotGroup = styled.g`
  transition: none; /* prevent rotation animation on side change */
  transform-origin: 148.5px 90px; /* center of 297x180 */
  transform-box: fill-box;

  &[data-side="2"] {
    transform: rotate(180deg);
  }
`;

const AttackPath = styled.path<{ x: number }>`
  transform: translateX(0);
  &[data-side="1"] {
    transform: translateX(0);
  }
  &[data-side="2"] {
    transform: translateX(0);
  }
`;
